import { useContext } from 'react';
import { CompaniesContext } from '../contexts/CompaniesProvider.tsx';

export const useUserCompanies = () => useContext(CompaniesContext);
